<template>
<section id="viewer">
    <div>
        <!-- select an account and segment -->
        <section>
            <div class="max-width">Select a Client</div>
            <v-select
                :options="customers"
                placeholder="User Profile"
                :searchable="true"
                label="company_name"
                v-model="selectedCustomer"
                @input="selectCustomer"
                :clearable="false" />
        </section>
        <!-- End: select an account and segment -->
        <!-- Main Tabs -->
        <div class="somemargin-top">
            <ul class="nav nav-tabs">
                <li
                    v-for="s in sources"
                    class="nav-item"
                >
                    <router-link
                        :to="{ path: '/data/' + s.route, query: query }"
                        :class="{active: s === source, 'nav-link': true}"
                    >
                        <i v-if="s.pluralName == 'accounts'" class="fa fa-building space-right"></i>
                        <i v-if="s.pluralName == 'contacts'" class="fa fa-users space-right"></i>
                        {{s.pluralName | capitalize}}
                    </router-link>
                </li>
            </ul>
        </div>
        <!-- End Main Tabs -->
        <section v-if="state === 'ready'">
            <div class="somemargin-top">
                <account-create-page
                    :customer="selectedCustomer"
                    v-if="source.name === 'account'" />
                <contact-create-page
                    :customer="selectedCustomer"
                    v-if="source.name === 'contact'" />
            </div>
        </section>
        <section v-if="state === 'loading'" class="flex">
            <div class="ui active inline loader large" style="margin: auto"></div>
        </section>
    </div>
</section>
</template>

<script>
import Conditions from '../conditions';
import account from '../source/account';
import contact from '../source/contact';

import ContactCreatePage from '../worker/record-details/record-pages/contact-create-page.vue';
import AccountCreatePage from '../worker/record-details/record-pages/account-create-page.vue';

const sources = [
    account,
    contact,
];

export default {
    name: 'Viewer',
    data: data,
    computed: {
        sources: function() {
            return sources;
        },
        source: source,
        conditions: conditions,
        query: query,
        state: state,
    },
    beforeRouteEnter: (to, from, next) => next((self) => self.init()),
    watch: {
        '$route': init,
        conditions: onConditionChange,
    },
    components: {
        'account-create-page': AccountCreatePage,
        'contact-create-page': ContactCreatePage,
    },
    methods: {
        init,
        findSource,
        setSourceByRoute,
        setConditionsByRoute,
        clearConditions,
        addCondition,
        replaceUrl,
        clearSelected,
        selectCustomer,
        loadSegmentSelects,
    }
};

function data() {
    return {
        defaultPageSize: null,
        sourceName: "",
        // filtering by customer/segment. accessible only by QA/Worker/PM
        customers: [],
        selectedCustomer: null,
    };
}

function clearConditions() {
    this.$store.commit(
        'setViewerConditions',
        this.conditions.filter((c) => c.key === 'project')
    );
}

function addCondition(condition) {
    this.clearSelected();
    this.$store.dispatch('addViewerCondition', condition);
}

function conditions() {
    return this.$store.getters.conditions;
}

function source() {
    return this.$store.state.viewer.source;
}

function state() {
    return this.$store.state.viewer.state;
}

function init() {
    if (!this.$route.params.sourceName) {
        this.$router.replace(this.sources[0].route);
    }

    // Route building
    this.setSourceByRoute(this.$route);

    return this.loadSegmentSelects()
        .then(() => this.$store.commit('setState', 'ready'));
}

function onConditionChange() {
    if (this.state !== 'ready') return;

    sources.forEach((source) => source.fresh = false);
    this.replaceUrl();
}

function replaceUrl() {
    this.$router.replace({
        name: this.$route.name,
        params: {
            sourceName: this.$route.params.sourceName
        },
        query: this.query
    });
}

function query() {
    if (!this.source) return;

    return Conditions.prototype.toQuery.call(
        this.$store.getters.conditions,
        this.$store.state.viewer.source.headers,
        this.$store.state.viewer.source.pagination,
        true
    );
}

function setSourceByRoute(route) {
    var source = this.findSource(route.params.sourceName);
    this.$store.dispatch('changeSource', source || this.sources[0]);
}

function setConditionsByRoute(query) {
    this.$store.dispatch('constructConditionsFromQuery', query);
}

function findSource(route) {
    return this.sources.find(s => { return s.route === route });
}

function clearSelected() {
    this.$store.commit('checkTracker/clearAll');
}

function selectCustomer(customer) {
    this.$data.selectedCustomer = customer;
    if (customer) {
        this.addCondition({key: 'user_profile_id', value: customer.id, 'static': true});
    }
}

function loadSegmentSelects() {
    return Vue.http.get('user/profile/assigned-profiles/')
        .then((response) => {
            this.$data.customers = response.body;
            // select initial segment and customer
            const query = this.$route.query;

            let customer = null;

            if (query.user_profile_id) {
                customer = this.customers.find(c => { return c.id === parseInt(query.user_profile_id) });
            }
            if (!customer) {
                customer = this.customers[0];
            }
            this.selectCustomer(customer);
        });
}
</script>
